module.exports = __webpack_public_path__ + "img/04.bb13a93c.jpg";